import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { loadCredentials } from '../../ducks/credentials'

function mapStateToProps (state, ownProps) {
  return {
    ...ownProps,
    fetched: state.credentials.fetched,
    fetching: state.credentials.fetching,
    list: state.credentials.list
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ loadCredentials }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/credentials/index.js